import { makeStyles } from '@material-ui/core';
import { theme } from '../../../../../../../theme';

/** Outlined text field styles aligned with MemberAutocomplete / Template dropdown. */
export const templateNameFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '50px',
    minHeight: '40px',
    backgroundColor: theme.textWhite.main,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.greyScale.slateGray,
  },
  '& .MuiInputLabel-root': {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: '14px',
    letterSpacing: '0.28px',
    color: theme.palette.primary.deep,
  },
  '& .MuiInputBase-input': {
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.32px',
    color: theme.palette.colors.grey110,
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.colors.grey90,
    opacity: 1,
  },
};

export const useTemplateNameSectionStyles = makeStyles((muiTheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  fieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    padding: '16px 0 0',
    boxSizing: 'border-box',
  },
  supportingText: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    minHeight: '20px',
    paddingRight: '16px',
  },
  infoIcon: {
    width: '12px',
    height: '12px',
    fontSize: '12px',
    color: muiTheme.palette.colors.grey110,
    flexShrink: 0,
  },
  helper: {
    color: muiTheme.palette.colors.grey110,
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: '0.24px',
  },
}));
